/*
 * File: cell-user-relations.ts
 * Created: 2025-12-05 17:01:22
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-05 17:01:32
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

/* src/lib/components/table/lib/cell-user-relations/cell-user-relations.ts */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "l", // 靠左對齊，或者根據您的表格佈局調整為 'c'
})
export default class CellUserRelations extends BaseTableBodyCell {
    // 獲取關聯帳號數量
    get accountsCount(): number {
        // 使用 Optional Chaining 避免 row._count 為 undefined 時報錯
        return this.row._count?.accounts ?? 0;
    }

    // 獲取關聯組織數量
    get organizationsCount(): number {
        return this.row._count?.organizations ?? 0;
    }
}
